import { render, staticRenderFns } from "./UtilityTab.vue?vue&type=template&id=0f2dec2e"
import script from "./UtilityTab.vue?vue&type=script&lang=js"
export * from "./UtilityTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports